import { createContext } from 'react';

import type { StatsScope } from '@/components/map/utils/resolveStatsScope';

export interface StatsScopeContextValue {
    /** The scope the Global Stats bar should show (network / area / dma). */
    scope: StatsScope;
    /** Publish a newly resolved scope. No-ops when the scope key is unchanged. */
    setScope: (scope: StatsScope) => void;
}

export const StatsScopeContext = createContext<StatsScopeContextValue | null>(null);
